export function formatDate(dateString: string | null): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

export function formatMonthYear(dateString: string | null): string {
  if (!dateString) return '';
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    month: 'short',
    year: 'numeric',
  });
}

export interface FacilityAddress {
  streetAddress?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export function formatAddress(address?: FacilityAddress | null): string {
  if (!address) return '-';

  const parts = [
    address.streetAddress,
    address.city,
    address.state,
    address.postalCode,
  ].filter(Boolean);

  return parts.length > 0 ? parts.join(', ') : '-';
}
